import { PLANS, PLAN_LEVELS } from '../../server/lib/constants'

export const userIsAtLeast = (user, atLeastPlan) => {
  if (!user) {
    return false
  }

  if (user.admin) {
    return true
  }

  if (atLeastPlan === PLANS.organizational) {
    return !!user.organizationLicense
  }

  const userLevel = PLAN_LEVELS[user.subscription?.plan] ?? -1
  const requiredLevel = PLAN_LEVELS[atLeastPlan] ?? Infinity
  return userLevel >= requiredLevel
}
